<template>
  <div class="division-row">
    <img :src="img"/>
    <div>
      <span :style="{background: bgColor}">{{text}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#fff'
    }
  }
}
</script>
<style lang="scss" scoped>
.division-row {
  // border-top: 1px solid rgb(136, 135, 135);
  text-align: center;
  padding: 0.5rem 0;
  box-sizing: border-box;
  img {
    width: 0.7rem;
  }
  div {
    font-size: 0.3rem;
    font-weight: bold;
    color: #333333;
    line-height: 0.5rem;
    span {
      position: relative;
      // background: #fff;
      padding: 0 0.2rem;
      z-index: 2;
      &::after {
        position: absolute;
        top: 50%;
        left: -1rem;
        right: -1rem;
        height: 0.02rem;
        background: #2D4978;
        content: '';
        z-index: -1;
      }
    }
  }
}
</style>